import React, { FC } from 'react'
import { HeroProps } from 'src/components/Hero/types'

import { MainLayoutProps } from '../../layouts'

import * as SC from './styled'

export type HomeTemplateProps = MainLayoutProps & {
  hero?: HeroProps
  children?: React.ReactNode
}

const HomeTemplate: FC<HomeTemplateProps> = ({
  children,
  hero,
  ...layoutProps
}) => {
  return (
    <SC.Layout {...layoutProps}>
      {hero && <SC.Hero {...hero} />}
      {children}
    </SC.Layout>
  )
}

export default HomeTemplate
